import { ScrollView } from "react-native"
import { useRewardsProgramData } from "@/queries/user"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Body, H3, H5, Tiny } from "@/components/standard/BFText"
import House from "@/assets/clipart/house.svg"
import RewardMoney from "@/assets/clipart/reward-money.svg"
import { Container } from "@/screens/rewards/components/Container"
import { StartALoanButton } from "@/screens/rewards/components/StartALoanButton"
import { PrimaryButton } from "@/components/buttons/CommonButtons"
import { useRefer } from "@/screens/rewards/utils"
import { ProgramDetailsButton } from "@/screens/rewards/components/ProgramDetailsButton"

export const EarningPointsTab = () => {
  const onRefer = useRefer("earning points")
  const { data: rewardsProgramData } = useRewardsProgramData()

  return (
    <ScrollView className={"bg-off-white flex-1 px-5"}>
      <Vertical>
        <Horizontal className={"gap-10 mt-8 mb-3"}>
          <Vertical className={"flex-1 justify-start"}>
            <H3 className={"text-midnight-blue mb-1"}>Flip More, Save More</H3>
            <Body className={"text-midnight-blue"}>
              The more deals you close with Backflip, the more points you earn
            </Body>
          </Vertical>
          <House width={80} height={76} />
        </Horizontal>

        {rewardsProgramData?.closesToPoints?.map((d) => (
          <Container key={d?.nthClose} className={"flex-row justify-between"}>
            <H5 className={"text-midnight-blue"}>
              {d?.nthCloseLabel} Loan Closed
            </H5>
            <H5 className={"text-calm-blue"}>
              +{" "}
              {d?.nextCloseReward?.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              })}{" "}
              pts
            </H5>
          </Container>
        ))}

        <StartALoanButton />

        <Horizontal className={"gap-10 my-5"}>
          <Vertical className={"flex-1 justify-center"}>
            <H3 className={"text-midnight-blue mb-1"}>Refer Your Friends</H3>
            <Body className={"text-midnight-blue"}>
              We&apos;ll give your friends 5,000 points toward their first deal,
              and you&apos;ll receive 5,000 points when they close.
            </Body>
            <Tiny className={"text-midnight-blue"}>
              *Per first loan for each referral. Unlimited referrals
            </Tiny>
          </Vertical>
          <RewardMoney width={76} height={62} />
        </Horizontal>

        <Container className={"flex-row justify-between"}>
          <H5 className={"text-midnight-blue"}>Referral&apos;s 1st Close</H5>
          <H5 className={"text-calm-blue"}>+ 5,000 pts</H5>
        </Container>

        <PrimaryButton
          onPress={onRefer}
          title={"Refer a Friend"}
          testID={"refer a Friend"}
          className={"mx-1 mt-6 "}
        />

        <ProgramDetailsButton />
      </Vertical>
    </ScrollView>
  )
}
